import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-grid-notes',
    templateUrl: './grid-notes.component.html',
    styleUrls: ['./grid-notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridNotesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
